import * as React from 'react';
import { styles } from './styles';
import { Transition } from 'react-transition-group';

interface Props {
  open: boolean;
  color?: BackdropColor;
}

export type BackdropColor = 'light' | 'dark';

export const Backdrop: React.SFC<Props> = ({ open, color = 'dark' as BackdropColor }) => {
  return (
    <Transition appear={true} in={open} timeout={{ enter: 0, exit: 200 }}>
      {(state: string) => {
        return (
          <div aria-hidden="true" className={`${styles.wrapper} ${styles.fade[state]}`}>
            <div className={styles.root(color)} />
          </div>
        );
      }}
    </Transition>
  );
};
